import * as THREE from 'three';

import React, { useRef } from 'react';

import { useFrame } from '@react-three/fiber';

interface ShurikenProps {
  position: [number, number, number];
  playerId: string;
}

export const Shuriken: React.FC<ShurikenProps> = ({ position }) => {
  const shurikenRef = useRef<THREE.Group>(null);

  // Add spinning animation
  useFrame(() => {
    if (shurikenRef.current) {
      shurikenRef.current.rotation.x += 0.2;
      shurikenRef.current.rotation.y += 0.2;
    }
  });

  return (
    <group ref={shurikenRef} position={position} scale={[0.5, 0.5, 0.5]}>
      {/* Shuriken center */}
      <mesh castShadow>
        <boxGeometry args={[0.2, 0.2, 0.2]} />
        <meshStandardMaterial color="#444444" metalness={0.8} roughness={0.2} />
      </mesh>

      {/* Shuriken blades */}
      <mesh castShadow position={[0.4, 0, 0]} rotation={[0, 0, Math.PI / 4]}>
        <boxGeometry args={[0.6, 0.1, 0.1]} />
        <meshStandardMaterial color="#777777" metalness={0.9} roughness={0.1} />
      </mesh>

      <mesh castShadow position={[-0.4, 0, 0]} rotation={[0, 0, Math.PI / 4]}>
        <boxGeometry args={[0.6, 0.1, 0.1]} />
        <meshStandardMaterial color="#777777" metalness={0.9} roughness={0.1} />
      </mesh>

      <mesh castShadow position={[0, 0.4, 0]} rotation={[0, 0, Math.PI / 4]}>
        <boxGeometry args={[0.1, 0.6, 0.1]} />
        <meshStandardMaterial color="#777777" metalness={0.9} roughness={0.1} />
      </mesh>

      <mesh castShadow position={[0, -0.4, 0]} rotation={[0, 0, Math.PI / 4]}>
        <boxGeometry args={[0.1, 0.6, 0.1]} />
        <meshStandardMaterial color="#777777" metalness={0.9} roughness={0.1} />
      </mesh>
    </group>
  );
};
